export const ATTACHMENTS_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  URL: 'url',
  GAME: 'game',
};
